import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

import type { ProgressBarAppearance, ProgressBarColor } from './ProgressBar'

interface FillerProps {
  appearance: ProgressBarAppearance
  color: ProgressBarColor
}

const getIonColorKey = (color: ProgressBarColor) => (color === 'main' ? 'primary' : color)

export const Container = styled.div`
  width: 100%;
  height: ${theme.sizes.ion.global.x8};
  border-radius: ${theme.radius.tags};
  overflow: hidden;
  background-color: ${theme.colors.ion.surface.lowest};
`

export const Filler = styled.div<FillerProps>`
  height: 100%;
  border-radius: inherit;
  transition: width 0.3s ease-in-out;
  background-color: ${({ appearance, color }) => {
    const palette = theme.colors.ion[getIonColorKey(color)]
    return appearance === 'soft' ? palette.soft : palette.main
  }};
`
